import moment from 'moment';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfigFile from '../css/tailwind.config';
import FLAG_FR from 'assets/images/flag-fr.svg'
import FLAG_MA from 'assets/images/flag-ma.svg'
import FLAG_UK from 'assets/images/flag-uk.svg'
import AR from 'assets/images/ar.svg'
import EN from 'assets/images/en.svg'
import FR from 'assets/images/fr.svg'
const CryptoJS = require("crypto-js");
const SECRET_KEY = '2@21MONCF'

export const tailwindConfig = () => {
  // Tailwind config
  return resolveConfig(tailwindConfigFile)
}

export const hexToRGB = (h) => {
  let r = 0;
  let g = 0;
  let b = 0;
  if (h.length === 4) {
    r = `0x${h[1]}${h[1]}`;
    g = `0x${h[2]}${h[2]}`;
    b = `0x${h[3]}${h[3]}`;
  } else if (h.length === 7) {
    r = `0x${h[1]}${h[2]}`;
    g = `0x${h[3]}${h[4]}`;
    b = `0x${h[5]}${h[6]}`;
  }
  return `${+r},${+g},${+b}`;
};

export const formatValue = (value) => Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumSignificantDigits: 3,
  notation: 'compact',
}).format(value);

export const getI18nValue = (i18nPath, key) => {
  return i18nPath + "." + key;
}

export const getDateRangeString = (dateRanges) => {
  return ("0" + dateRanges?.startDate?.getDate()).slice(-2) + "_" + ("0" + (dateRanges?.startDate?.getMonth() + 1)).slice(-2) + "_" +
    dateRanges?.startDate?.getFullYear() + "_to_" + ("0" + dateRanges?.endDate?.getDate()).slice(-2) + "_" + ("0" + (dateRanges?.endDate?.getMonth() + 1)).slice(-2) + "_" +
    dateRanges?.endDate?.getFullYear();
}

export const getChannelLanguageString = (channel, language) => {
  if (!channel && !language) return "";

  let result = "_";
  if (channel) result = result + channel;
  if (language) result = result + "_" + language;
  
  return result;
}



export const formatDateTime = (date) => {
  return date ? moment(date).local().format("DD MMM YYYY - HH:mm") : '-';
}

// Converts a JS Date to a Unix timestamp at UTC midnight of its *local* calendar date.
// This prevents timezone shifts: "Mar 31 local" always sends 2026-03-31T00:00:00Z,
// not 2026-03-30T23:00:00Z (which is what moment(date).unix() gives for UTC+1 users).
const toUTCMidnightUnix = (date) => {
  const d = new Date(date);
  return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 1000;
};

export const dateRangeUriEncode = (dateRanges) => {
  if (!dateRanges) return '';
  return `startDate=${toUTCMidnightUnix(dateRanges.startDate)}&endDate=${toUTCMidnightUnix(dateRanges.endDate)}`;
}

export const languageUriEncode = (language) => {
  return language ? `lang=${language}` : 'all'

}
export const stationUriEncode = (stationCode) => {
  return stationCode ? `lang=${stationCode}` : ''
}


export const getLanguageFlag = (languageKey) => {
  let languageList = {
    'ar': AR,
    'fr': FR,
    'en': EN,
    'arabic_dialect_ma': FLAG_MA,
    'arabic': FLAG_MA,
    'french': FLAG_FR,
    'english': FLAG_UK,
    'default': null
  };
  return (languageList[languageKey] || languageList['default']);
}


export const getLanguageKey = (language) => {
  let languageList = {
    'ar': "ar",
    'fr': "fr",
    'en': "en",
    'arabic_dialect_ma': "drj",
    'arabic': "ar",
    'french': "fr",
    'english': "en",
    'default': null,
    'Français': 'fr',
    'Arabic': 'ar',
    'English': 'en'
  };
  return (languageList[language] || languageList['default']);
}


export function getLanguage(key) {
  switch (key) {
    case "ar":
      return "arabic"
    case "en":
      return "english"
    case "fr":
      return "french"
    default:
      return "french"
  }
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}


export const getReduxActionType = (value, action, type) => {
  return (value + action + type).toUpperCase().replaceAll(/\s/g, "");
}

export function isImageUrlValid(url) {
  const regex = new RegExp(/^http[^ !@$^&()+=]+(.png|.jpeg|.jpg)$/);
  return regex.test(url)
}


export function AESEncrypt(pureText) {
  const privateKey = `${SECRET_KEY}`;
  const ciphertext = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(pureText), privateKey).toString());
  return ciphertext;
}

export function AESDecrypt(encryptedText) {
  if (encryptedText) {
    const privateKey = `${SECRET_KEY}`;
    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedText), privateKey);
    try {
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (e) {
      console.error(e);
      return null;
    }
  }
}



